<h2>{{ title }}</h2>
<rr-select
    label="Closing Asset"
    [(ngModel)]="closingPromptId"
    [options]="closingStreamTypes"
    [preselectedValue]="closingPromptId"
    optionName="name"
    optionValue="id"
></rr-select>
<rr-input [(ngModel)]="resultTitle" label="Name of Asset"></rr-input>
<div class="w100 justify-end row gap-8">
    <rr-btn type="secondary" (click)="onCancel()"> Cancel </rr-btn>
    <rr-btn
        type="primary"
        (click)="onSave()"
        [disabled]="
            !resultTitle ||
            resultTitle === '' ||
            !closingPromptId ||
            closingPromptId === ''
        "
        >{{ editMode === true ? "Save Result" : "Add Result" }}</rr-btn
    >
</div>
